import {
    ASSIGN_INTERVIEW_REQUEST,
    ASSIGN_INTERVIEW_SUCCESS,
    ASSIGN_INTERVIEW_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const getAssignInterviewsReducer = (state = initialState, action) => {
    switch (action.type) {
        case ASSIGN_INTERVIEW_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case ASSIGN_INTERVIEW_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case ASSIGN_INTERVIEW_FAILURE:
            return {
                resFailMSg: true,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default getAssignInterviewsReducer;